module.exports = __webpack_public_path__ + "img/box_cng_grey.52a2245b.png";